export default {"src":"/_next/static/media/bg_blue_t.f2f3980d.svg","height":698,"width":1023,"blurWidth":0,"blurHeight":0};